module.exports = __webpack_public_path__ + "static/truck_unloading-f849ea724a63700f2e5e4311951679ff.jpg";